export class SortOrder  {

    readonly ASC : string = "asc";
    readonly DESC : string = "desc";
}